import { CircularProgress, Radio } from "@mui/material";
import React, { useCallback } from "react";
import { FlatList, TouchableOpacity, Text, View, StyleSheet, ScrollView } from "react-native";
import EmptyListCompnoent from "@common/component/EmptyListComponent";
import { FONT_FAMILY, THEME_COLORS } from "@common/themes";
import { isCloseToBottom } from "@src/utils/functions";

interface VerifierProps {
  data: any[];
  selected: { userId: number; fullName: string };
  onSelect: (userId: number | string) => void;
  canLoadMorePages: boolean;
  onEndReached: () => void;
}

function PodVerifierListing({ data, selected, onSelect, canLoadMorePages, onEndReached }: VerifierProps) {
  const renderItem = useCallback(
    (item) => {
      return (
        <TouchableOpacity activeOpacity={0.8} style={styles.itemContainer} onPress={() => onSelect(item)}>
          <View style={[styles.itemView, selected?.userId == item?.userId ? styles.selected : styles.unselected]}>
            <Radio checked={selected?.userId == item?.userId} color="primary" value={1} name="cgt" />
            <View style={[styles.flexContainer, styles.flexRow]}>
              <Text style={styles.text}>{item?.fullName}</Text>
            </View>

            <View style={styles.flexContainer}>
              <Text style={[styles.text, { textAlign: "center" }]}>{item?.podVerifierWorkCount}</Text>
            </View>
          </View>
        </TouchableOpacity>
      );
    },
    [selected]
  );

  return (
    <View style={styles.outerContainer}>
      <View style={[styles.itemView, { paddingVertical: 0, paddingLeft: 58 }]}>
        <View style={styles.flexContainer}>
          <Text style={styles.header}>Name</Text>
        </View>

        <View style={styles.flexContainer}>
          <Text style={[styles.header, { textAlign: "center" }]}>Total Assignments</Text>
        </View>
      </View>
      <ScrollView
        showsVerticalScrollIndicator={false}
        onScroll={({ nativeEvent }) => {
          if (isCloseToBottom(nativeEvent) && canLoadMorePages) {
            onEndReached?.();
          }
        }}
      >
        {data?.length > 0 ? (
          data?.map((item, index) => {
            const isLastValue = data?.length - 1 === index;
            return (
              <>
                {renderItem(item)}
                {isLastValue && canLoadMorePages ? (
                  <View style={styles.bottomLoader}>
                    <CircularProgress />
                  </View>
                ) : null}
              </>
            );
          })
        ) : (
          <EmptyListCompnoent emptyListText={"No POD Verifier is available to assign"} />
        )}
      </ScrollView>
      {/* <FlatList
                data={data}
                scrollEnabled
                renderItem={renderItem}
                extraData={selected}
                keyExtractor={(item) => item.userId.toString()}
                ListEmptyComponent={() => <EmptyListCompnoent emptyListText={'No POD Verifier is available to assign'} />}
            /> */}
    </View>
  );
}

const styles = StyleSheet.create({
  flexContainer: {
    flex: 1,
  },
  outerContainer: { maxHeight: "75%" },
  itemContainer: {
    cursor: "pointer",
  },
  itemView: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 5,
  },
  selected: {
    backgroundColor: THEME_COLORS.sideMenuBg,
  },
  unselected: {
    border: `1px solid ${THEME_COLORS.sideMenuBg}`,
  },
  header: {
    fontFamily: FONT_FAMILY.semiBoldV3,
    fontSize: 15,
  },
  text: {
    fontSize: 15,
    fontFamily: FONT_FAMILY.primaryV3,
  },
  badgeText: {
    color: THEME_COLORS.white,
    textTransform: "uppercase",
  },
  suggestionBadge: { backgroundColor: THEME_COLORS.purple2, padding: 8, marginLeft: 6, height: 24, borderRadius: 12 },
  flexRow: { flexDirection: "row", alignItems: "center" },
  bottomLoader: { width: "100%", marginVertical: 10, alignItems: "center" },
});

export default React.memo(PodVerifierListing);
